goog.provide('el8.ptdata.model.documentImage');

goog.require('el8.model.base');


(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('url');
    _class.addIntProperty('docId');

    el8.ptdata.model.documentImage = function(spec) { return new _class(spec); };

})();

